module.exports = __webpack_public_path__ + "img/attendance.0529b55.png";